module.exports = __webpack_public_path__ + "img/volume.ac9f2dd3.svg";